<template>
  <nav>
    <VTabsV2
      :tabs="tabs"
      base-url="/flow/preorders"
      @update="onTabUpdate"
    />
  </nav>

  <!-- Позиции предзаказов (в работе / доставленные / отменённые) -->
  <PreordersRegistry
    v-if="positionState !== null"
    ref="positionsRegistry"
    :state="positionState"
    :hidden-columns="['status']"
    :filter-class="filterClass"
    :show-action-bar="positionState === 'in-work'"
  />
</template>

<script lang="ts">
import PreordersRegistry   from '@/domains/Preorders/components//PreordersRegistry.vue';
import PreordersService    from '@/domains/Preorders/PreordersService';
import OrdersPageFilter    from '@/domains/Orders/components/OrdersFlow/OrdersPageFilter/OrdersPageFilter';
import TabElement          from '@/lib/components/VTabsV2/TabElement';

/**
 * Вкладки потока предзаказов строятся из PreordersService.States: у предзаказа
 * вкладка и состояние позиции — одно и то же, второй список завёл бы вторую
 * правду. Счётчиков нет: бэк их для предзаказов не отдаёт.
 *
 * Функция модульного уровня, а не метод: нужна уже в data(), где методы
 * компонента ещё не гарантированы, и в this не нуждается.
 */
function buildFlowTabs(): TabElement[] {
  const result: TabElement[] = [];

  for (const state of PreordersService.States) {
    result.push(TabElement.from(state.id, state.name, null, false));
  }

  return result;
}

export default defineComponent({
  name: 'PreordersFlow',

  components: {
    PreordersRegistry,
  },

  data() {
    return {
      filterClass: OrdersPageFilter,
      tabs:        buildFlowTabs(),

      /**
       * Активная вкладка — сообщает VTabsV2 (@update), страница роут
       * не парсит. Заполняется до mounted: VTabsV2 эмитит начальное
       * значение из своего created (immediate watch).
       */
      activeTab: null as TabElement | null,
    };
  },

  computed: {
    /**
     * state для PreordersRegistry, если активная вкладка — реестр позиций,
     * иначе null.
     */
    positionState(): string | null {
      const isPositionState = PreordersService.States.some(state => state.id === this.activeTab?.id);

      if (isPositionState) {
        return this.activeTab?.id ?? null;
      }
      else {
        return null;
      }
    },
  },

  methods: {
    /** Активную вкладку сообщает VTabsV2 — из роута в router-mode */
    onTabUpdate(tab: TabElement | null) {
      this.activeTab = tab;
    },
  },
});
</script>